import { useQuery } from "@tanstack/react-query";
import { useConvex } from "convex/react";
import { api } from "../../convex/_generated/api";

/**
 * Polls checkThreadHealth via TanStack useQuery's timer (no useEffect/setTimeout)
 * while streaming; server decides alive/slow-tool/dead and schedules
 * finalizeIfStillPending on death. Shared by web ChatPage and Outlook add-in Chat;
 * returns nothing — UI updates via the live lastRunOutcome/statusText query.
 */
export function useAgentHealthPoller({
	clericalThreadId,
	isStreaming,
	isTerminal,
	intervalMs = 30_000,
}: {
	clericalThreadId: string;
	isStreaming: boolean;
	isTerminal: boolean;
	intervalMs?: number;
}) {
	const convex = useConvex();
	useQuery({
		queryKey: ["agentHealthCheck", clericalThreadId],
		queryFn: () =>
			convex.mutation(api.agent.index.checkThreadHealth, { clericalThreadId }),
		refetchInterval: intervalMs,
		enabled: isStreaming && !isTerminal,
		staleTime: 0,
		gcTime: 0,
		retry: false,
	});
}
